import request from '@/config'
import { CategoryCfgSearch, CategoryCfgDeleteDto, CtCategoryCfgBase, AuditMemberSearch, CreateDeptPostsRelDto, CatDeptRelSearchDto } from './categorycfg.dto';

enum Apis {
    InsDeptPostsRelApi = `/api/basiccatrules/createdeptpostsrel`,
    CatDeptRelListApi = `/api/basiccatrules/getdeptpostsrellist`,
    CatDeptRelDelApi = `/api/basiccatrules/deletedeptrel`,
    DeptRelInfoApi = `/api/basiccatrules/getdeptpostinfo`,
}

/* 合同分类(配置-部门)关联数据列表 */
const GetCatDeptRelListApi = (search: CatDeptRelSearchDto): Promise<IResponse> => {
    return request.post({ url: Apis.CatDeptRelListApi, data: search })
}

/* 创建合同分类(配置-部门)关联 */
const CreateDeptRelApi = (input: CreateDeptPostsRelDto): Promise<IResponse> => {
    return request.post({ url: Apis.InsDeptPostsRelApi, data: input })
}

/* 删除合同分类(配置-部门)关联数据 */
const DelDeptRelApi = (input: CreateDeptPostsRelDto): Promise<IResponse> => {
    return request.post({ url: Apis.CatDeptRelDelApi, data: input })
}

const GetDeptPostRelInfoApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: Apis.DeptRelInfoApi, data: { id: rowId } })
}


export {
    GetCatDeptRelListApi,
    CreateDeptRelApi,
    DelDeptRelApi,
    GetDeptPostRelInfoApi,
}


/* 分类创建 */
export const CategoryCfgPagedApi = (search: CategoryCfgSearch): Promise<IResponse> => {

    return request.post({ url: '/api/ctcategorycfg/getpagelist', data: search })

}

/* 删除某个分类 */
export const DeletionApi = (deleteDto: CategoryCfgDeleteDto): Promise<IResponse> => {

    return request.post({ url: '/api/ctcategorycfg/deletion', data: deleteDto })

}

/* 获取某个分类明细 */
export const GetDetailApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: '/api/ctcategorycfg/getdetail', data: { id: rowId } })

}

/* 获取某个分类明细 */
export const ConfigCreateApi = (createData: CtCategoryCfgBase): Promise<IResponse> => {

    return request.post({ url: '/api/ctcategorycfg/create', data: createData })

}


/* 获取某个分类明细 */
export const ConfigEditApi = (editData: CtCategoryCfgBase): Promise<IResponse> => {

    return request.post({ url: '/api/ctcategorycfg/modify', data: editData })

}


/* 获取审批用户 */
export const GetAuditMembersApi = (search: AuditMemberSearch): Promise<IResponse> => {

    return request.post({ url: '/api/basiccatrules/getauditusers', data: search })

}









// /* 分类创建 */
// export const CategoryModifyApi = (createDto: CategoryEditDto): Promise<IResponse> => {

//     return request.post({ url: '/api/ctcategory/modify', data: createDto })

// }

// /* 分类删除 */
// export const CategoryDelApi = (createDto: CategoryDeleteDto): Promise<IResponse> => {

//     return request.post({ url: '/api/ctcategory/deletion', data: createDto })

// }

// /* 获取分类明细 */
// export const GetCategoryApi = (rowId: string): Promise<IResponse> => {

//     return request.post({ url: '/api/ctcategory/getdetail', data: { id: rowId } })

// }

// /* 获取分类列表 */
// export const GetCategoryListApi = (search: CategorySearch): Promise<IResponse> => {

//     return request.post({ url: '/api/ctcategory/getcategorylist', data: { id: search } })

// }

// /* 获取分类列表 */
// export const GetCategoryTreeApi = (search: CategoryBaeSearch): Promise<IResponse> => {

//     return request.post({ url: '/api/ctcategory/gettreelist', data: search })

// }


